import * as React from 'react';
import PropTypes from 'prop-types';
import PNRItemContainer from '../PNRItem/PNRItemContainer';
import PNRItemContainerFlightsPrevious from '../PNRItem/PNRItemContainerFlightsPrevious';
import FilterFlightContainer from '../FilterFlightContainer/FilterFlightContainer';
import { Row, Col } from 'antd';
import i18n from 'i18n-react';
import '../PNRItem/PNRItemContainer.css';
import $ from 'jquery';
import moment from 'moment';
import { ControlLabel } from 'react-bootstrap';

const propTypes = {
  searchResult: PropTypes.any
};

class PNRListContainer extends React.Component {
  constructor(props) {
    super(props);

  this.state = {
			searchResultFilter: null
		}
    
    this.setFilteredList = this.setFilteredList.bind(this);
		this.showModal = this.showModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.setCallbackErrorChangeTrip = this.setCallbackErrorChangeTrip.bind(this)
  }

  componentDidMount() {
    let scrollSearchPnr = sessionStorage.getItem('scrollSearchPnr');
    window.scroll(0, scrollSearchPnr ? scrollSearchPnr : 0);
  }

  setFilteredList(filteredList) {
		this.getFilterValues(filteredList);
	}

	getFilterValues(filteredList) {
		let searchResult = this.props.searchResult;
		var searchResultFilter = [];
		const { listCompany, flightOrigin, flightDestiny, data } = filteredList;

		searchResult.map((search) => {
			search.cart.items.map((item) => {

				var isFlightOrigin = true;
				var isFilterCompany = true;
				var isFlightDestiny = true;
				var isData = true;

				if (listCompany) {
					isFilterCompany = this.verifyCompaniesFilter(item.departureFlight, listCompany);
					if (!isFilterCompany && item.returnFlight)
						isFilterCompany = this.verifyCompaniesFilter(item.returnFlight, listCompany);
				}

				if (flightOrigin)
					isFlightOrigin = item.origin === flightOrigin.code || (item.returnFlight ? item.destination === flightOrigin.code : false);

				if (flightDestiny)
					isFlightDestiny = item.destination === flightDestiny.code || (item.returnFlight ? item.origin === flightDestiny.code : false);

				if (data) {
					const dateFormat = moment(data).format('DD/MM/YYYY');
					isData = item.departureFlight.departureDate === dateFormat || (item.returnFlight ? item.returnFlight.departureDate === dateFormat : false);
				}

				if (isFilterCompany && isFlightOrigin && isFlightDestiny && isData)
					searchResultFilter.push(search)
			});

		});

		this.setState({
			searchResultFilter: searchResultFilter
		});

	}

	verifyPnrExists(searchFilter, pnrFilter) {
		return searchFilter.filter((search) => search.pnrId === pnrFilter).length > 0
	}

	verifyCompaniesFilter(flight, value) {
		return flight.flightGroup.filter((group) => group.marketingCarrier !== undefined && value.includes(group.marketingCarrier)).length > 0
	}

	setCallbackErrorChangeTrip(msg) {
		this.addScroll();
		this.showModal(msg);
	}
 
  addScroll() {
		$('body').css('overflow-y', 'auto');
	}
  
  render() {
    let renderList = <div />;
    const search = this.getSearchRender();
    if(this.props.searchResult && this.props.searchResult.length <= 1){
      renderList = (
        <Row>
          <Col className="PNRListContainer__content">
            {this.props.searchResult.map((item, index) => {
              if (item.status === "ACTIVE" || item.status ==="REALLOCATION")
                return (
                  <div key={index} data-test={`pnrItem-${index}`} className={`pnrItem-${index}`}>
                    <PNRItemContainer 
                      data={item} 
                      azulNumber={this.props.azulNumber} 
                      hideCancelButton={true}
                      hideChangeTripButton={true}
                      />
                  </div>
                );

            })}
          </Col>
        </Row>
      );
    }else{
      if(search){
        renderList = (
          <div>
            {this.renderFilterFlight()}
            {this.renderNoResult()}
          <Row>
            <Col className="PNRListContainer__content">
              {search.map((item, index) => {
                if ((item.status === "ACTIVE" || item.status ==="REALLOCATION") && this.isFlightDateBiggerThanCurrentDate(item))
                  return (
                    <div key={index} data-test={`pnrItem-${item.pnrId.toString()}`} className={`pnrItem-${item.pnrId.toString()}`}>
                      <PNRItemContainer 
                        data={item} 
                        azulNumber={this.props.azulNumber} 
                        hideCancelButton={true}
                        hideChangeTripButton={true}
                        key={item.pnrId.toString()}
                        compareDate={this.isFlightDateBiggerThanCurrentDate(item)}
                        />
                    </div>
                  );
              })}
            </Col>
          </Row>
          </div>
        );
      }
    }
    return <div className="PNRListContainer">{renderList} {this.renderflightsPrevious()} </div>;
  }

  isFlightDateBiggerThanCurrentDate(item) {
    let presentDate = moment().startOf('day');
    return item.cart.items[0].returnFlight === null && moment(item.cart.items[0].departureFlight.departureDate, "DD/MM/YYYY") >= presentDate
      || item.cart.items[0].returnFlight !== null && moment(item.cart.items[0].returnFlight.departureDate, "DD/MM/YYYY") >= presentDate;
  }

  renderflightsPrevious() {
    let renderListflightsPrevious = <div />;
    let renderTitle = <div />;
    const search = this.getSearchRender();
    
      if(search){  
        renderTitle = (
          this.renderTitle(search)
          )        
        renderListflightsPrevious = (
          <div>
            <Row>
              <Col className="PNRListContainer__content">
                {search.map((item, index) => {
                  if (item.status === "FLOWN" || item.status === "CANCELED" || item.status === "CANCEL_IN_PROGRESS" || ((item.status === "ACTIVE" || item.status ==="REALLOCATION") && !this.isFlightDateBiggerThanCurrentDate(item)))
                    return (
                      <div key={index} data-test={`pnrItem-${item.pnrId.toString()}`} className={`pnrItem-${item.pnrId.toString()}`}>
                        <PNRItemContainerFlightsPrevious key={item.pnrId.toString()} data={item} azulNumber={this.props.azulNumber} />
                      </div>
                    );
                })}
              </Col>
            </Row>
          </div>
        );
      }
    return <div className="PNRListContainer">{renderTitle}{renderListflightsPrevious} </div>;
  }

  getSearchRender() {
		const renderSearchResultFilter = this.state.searchResultFilter;
		const renderSearchResult = this.props.searchResult && this.props.searchResult.length > 0;
		return renderSearchResultFilter ? this.state.searchResultFilter : renderSearchResult ? this.props.searchResult : null;
	}

	renderNoResult() {
		if (this.state.searchResultFilter && this.state.searchResultFilter.length === 0)
			return (
        <Row className="container-not-found">
          <Col>
            <ControlLabel id="lblResultNotFound" className="message-not-found">
              {i18n.translate('filters.filterNotFound')}
            </ControlLabel>
          </Col>
        </Row>
      )
  }

  renderTitle(value) {
    if(this.verifyStatusPnr(value) >= 1){
        return(
          <div>
            <Row className="text-xl text-dark-blue flightsPrevious">
              {i18n.translate('features.pnrItemContainer.flightsPrevious')}
            </Row>
          </div>
        );
      }
    }

  verifyStatusPnr(value) {
    let count = 0;
    value.map((item, index) =>
      item.status === "FLOWN" || item.status === "CANCELED" || item.status === "CANCEL_IN_PROGRESS" || ((item.status === "ACTIVE" || item.status ==="REALLOCATION") && !this.isFlightDateBiggerThanCurrentDate(item)) ? count++ : count); 
    return count;
  }
  
  renderFilterFlight() {
		return (
			<FilterFlightContainer
				searchResult={this.props.searchResult}
				callbackFilteredList={this.setFilteredList}
			/>
		)
	}

  closeModal() {
		this.setState({
			openModal: false,
			messageInfo: null
		});

	}

	showModal(message) {
		this.setState({
			openModal: true,
			messageInfo: message
		});
	}
}

PNRListContainer.propTypes = propTypes;
export default PNRListContainer;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/PNRList/PNRListContainer.jsx